export function isCprOver18(cpr: string) {
  const regex = new RegExp(
    /^(?<day>\d{2})(?<month>\d{2})(?<year>\d{2})(?<century>\d{1})/
  );

  const result = regex.exec(cpr);

  if (!result?.groups) return false;

  const day = Number(result.groups.day);
  const month = Number(result.groups.month);
  const year = Number(result.groups.year);
  const birthDate = new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
  const now = new Date();

  const diff = now.getTime() - birthDate.getTime();
  const diffInDays = Math.floor(diff / 1000 / 86400);

  // 18 years = 6570 days.
  if (diffInDays < 6570) {
    return false;
  }

  return true;
}

export function validCpr(cpr: string) {
  const controlDigits = [4, 3, 2, 7, 6, 5, 4, 3, 2, 1];

  const sum = cpr
    .split('')
    .reduce((sum, digit, i) => sum + Number(digit) * controlDigits[i], 0);

  if (sum % 11 !== 0) {
    return false;
  }

  if (11 - (sum % 11) === parseInt(cpr[9])) {
    return false;
  }

  return true;
}
